import { H1, TextRegular } from "@hm/fundamental"
import NoProjectsImage from "@shared/assets/no-projects.svg"
import { useTranslation } from "react-i18next"

export const NoProjects = () => {
	const { t } = useTranslation("features", {
		keyPrefix: "projectsList.noProjects",
	})
	return (
		<div
			className="flex flex-col justify-center items-center mt-8"
			data-cy="no-projects"
		>
			<img src={NoProjectsImage} alt="No Projects" />
			<div className="flex flex-col items-center gap-6 mt-8 w-[400px]">
				<H1 className="text-center">{t("createDeclaration")}</H1>
				<TextRegular className="text-foreground_faded text-center">
					{t("description")}
				</TextRegular>
			</div>
		</div>
	)
}
